import { GenericMapping, GenericMappingType } from '../../search/types'

export const JIRA_GENERIC_MAPPINGS: GenericMapping[] = [
  {
    key: 'project',
    type: GenericMappingType.KEYWORD,
    name: 'Project',
    description: 'Project the issue belongs to',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'dueDate',
    type: GenericMappingType.DATE,
    name: 'Due date',
    description: 'Expected date of resolution for the issue',
  },
  {
    key: 'assignee',
    type: GenericMappingType.KEYWORD,
    name: 'Assignee',
    description: 'Assignee responsible of the issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'reporter',
    type: GenericMappingType.KEYWORD,
    name: 'Reporter',
    description: 'User who reported the issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'priority',
    type: GenericMappingType.KEYWORD,
    name: 'Priority',
    description: 'Priority issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'status',
    type: GenericMappingType.KEYWORD,
    name: 'Status',
    description: 'Status of the issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'resolution',
    type: GenericMappingType.KEYWORD,
    name: 'Resolution',
    description: 'Contains explanation about how the issue was resolved',
  },
  {
    key: 'type',
    type: GenericMappingType.KEYWORD,
    name: 'Type',
    description: 'Type of the issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'creator',
    type: GenericMappingType.KEYWORD,
    name: 'Creator',
    description: 'Creator of the issue',
    enumFromCollapseEsQuery: true,
  },
  {
    key: 'key',
    type: GenericMappingType.KEYWORD,
    name: 'Identifier',
    description: 'Human readable issue identifier',
  },
  {
    key: 'labels',
    type: GenericMappingType.KEYWORD,
    name: 'Labels',
    description: 'Labels set on the issue',
    enumFromTermsAggEsQuery: true,
  },
  {
    key: 'percentProgress',
    type: GenericMappingType.NUMBER,
    name: 'Progress in percent',
    description: 'Completion progress of the issue in percent',
  },
  {
    key: 'resolutionDate',
    type: GenericMappingType.DATE,
    name: 'Resolution date',
    description: 'Date when the issue was resolved',
  },
  {
    key: 'timeSpent',
    type: GenericMappingType.NUMBER,
    name: 'Time spent',
    description: 'Time spent on the issue',
  },
] as const
